var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$.create_column_view }, [
    _c("div", { class: _vm.$.create_column_view__body }, [
      _c(
        "div",
        { class: [_vm.$.slot, _vm.$.slot__name] },
        [
          _c("vgp-label-slot", {
            attrs: { label: _vm.locale("columns_bar_new_column_input_label") },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c("vgp-input", {
                      ref: "nameInput",
                      attrs: {
                        value: _vm.name,
                        small: true,
                        placeholder: _vm.column.name,
                      },
                      on: {
                        onChange: _vm.onColumnNameChange,
                        input: _vm.onInput,
                      },
                      model: {
                        value: _vm.name,
                        callback: function ($$v) {
                          _vm.name = $$v
                        },
                        expression: "name",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showMatchesMessage && !_vm.closedMessageByUser
        ? _c("div", { class: _vm.$.message }, [
            _c("div", { class: _vm.$.wrapper }, [
              _c(
                "div",
                { class: _vm.$.info },
                [
                  _c("svg-sprite", {
                    attrs: {
                      type: "bold",
                      name: "info",
                      size: 20,
                      color: "#1565C0",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { class: _vm.$.text }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.locale(
                            "columns_bar_message_if_name_already_exist"
                          )
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: _vm.$.close, on: { click: _vm.closeMessage } },
                    [
                      _c("svg-sprite", {
                        attrs: { name: "close-1", size: 16 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.$.button },
                [
                  _c("vgp-button", {
                    attrs: {
                      id: "gp_autotest_columns_bar_message_open_existed_columns_tab",
                      label: _vm.locale(
                        "columns_bar_message_open_existed_columns_tab"
                      ),
                      type: "primary",
                      "x-small": true,
                    },
                    on: { onClick: _vm.showExistingColumnsByUserValue },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: [_vm.$.slot, _vm.$.slot__custom_column] },
        [
          _c("vgp-label-slot", {
            attrs: {
              label: _vm.locale("columns_bar_new_column_types_select_label"),
            },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c("dropdown-select", {
                      attrs: {
                        "drop-list": _vm.columnTypes,
                        multiselect: false,
                        "show-selected-first": false,
                        "show-reset-btn": false,
                        "highlight-active-state": false,
                        "item-template": "withIcon",
                        "track-by-item-tooltip": "tooltip",
                        "track-by-text": "name",
                        "track-by-icon-name": "icon",
                        "popup-max-height": 305,
                        selected: _vm.columnTypes.find(function (i) {
                          return i.id === _vm.column.id
                        }),
                      },
                      on: { selected: _vm.onSelectColumnType },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.columnType === "select"
        ? _c(
            "div",
            {
              ref: "options",
              class: [
                _vm.$.slot,
                _vm.$.slot__options,
                _vm.$.slot__option_select,
              ],
            },
            [
              _c("vgp-label-slot", {
                attrs: {
                  label: _vm.locale("columns_bar_select_options_label"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("select-options", {
                            attrs: {
                              options: _vm.userOptions,
                              "max-height": _vm.optionsListMaxHeight,
                              error: _vm.errorValidation,
                            },
                            on: {
                              resetError: _vm.resetError,
                              onChange: _vm.changeOptions,
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  212728808
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.columnType === "number"
        ? _c(
            "div",
            { class: [_vm.$.slot, _vm.$.slot__option_number] },
            [
              _c("vgp-label-slot", {
                attrs: {
                  label: _vm.locale("columns_bar_aggregations_options_label"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("dropdown-select", {
                            attrs: {
                              "drop-list": _vm.optionsAggregations,
                              multiselect: false,
                              "show-selected-first": false,
                              "show-reset-btn": false,
                              "highlight-active-state": false,
                              "item-template": "text",
                              "track-by-text": "value",
                              "popup-max-height": 100,
                              selected: _vm.userOptions,
                            },
                            on: { selected: _vm.changeOptions },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  99324716
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.columnType === "colors"
        ? _c(
            "div",
            {
              ref: "options",
              class: [
                _vm.$.slot,
                _vm.$.slot__options,
                _vm.$.slot__option_colors,
              ],
            },
            [
              _c("vgp-label-slot", {
                attrs: {
                  label: _vm.locale("columns_bar_colors_options_label"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("color-options", {
                            attrs: {
                              options: _vm.userOptions,
                              "max-height": _vm.optionsListMaxHeight,
                            },
                            on: { onChange: _vm.changeOptions },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3986139958
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.columnType === "multiselect"
        ? _c(
            "div",
            {
              ref: "options",
              class: [
                _vm.$.slot,
                _vm.$.slot__options,
                _vm.$.slot__option_multiselect,
              ],
            },
            [
              _c("vgp-label-slot", {
                attrs: {
                  label: _vm.locale("columns_bar_multiselect_options_label"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("multiselect-options", {
                            attrs: {
                              options: _vm.userOptions,
                              "max-height": _vm.optionsListMaxHeight,
                              error: _vm.errorValidation,
                            },
                            on: {
                              resetError: _vm.resetError,
                              onChange: _vm.changeOptions,
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3922880545
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.columnType === "resources"
        ? _c(
            "div",
            { class: [_vm.$.slot, _vm.$.slot__option_resources] },
            [
              _c("vgp-label-slot", {
                attrs: {
                  label: _vm.locale("columns_bar_resources_options_label"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("dropdown-select", {
                            attrs: {
                              "drop-list": _vm.groupedResources,
                              placeholder: _vm.locale(
                                "columns_bar_resources_select_placeholder"
                              ),
                              multiselect: true,
                              "show-selected-first": false,
                              "show-reset-btn": false,
                              "highlight-active-state": false,
                              "devider-color": "#999999",
                              "use-search": true,
                              "item-template": "user",
                              "track-by-text": "name",
                              "group-by": "group",
                              "use-select-all": true,
                              "popup-max-height": 200,
                              selected: _vm.userOptions,
                            },
                            on: { selected: _vm.changeOptions },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3491040148
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.columnType === "tags"
        ? _c(
            "div",
            {
              ref: "options",
              class: [_vm.$.slot, _vm.$.slot__options, _vm.$.slot__option_tags],
            },
            [
              _c("vgp-label-slot", {
                attrs: { label: _vm.locale("columns_bar_tags_options_label") },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("tag-options", {
                            attrs: {
                              options: _vm.userOptions,
                              "max-height": _vm.optionsListMaxHeight,
                              error: _vm.errorValidation,
                            },
                            on: {
                              resetError: _vm.resetError,
                              onChange: _vm.changeOptions,
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  213736370
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { ref: "footer", class: _vm.$.create_column_view__footer },
      [
        _c("vgp-button", {
          attrs: {
            id: "gp_autotest_columns_bar_save_new_column",
            label: _vm.locale("common_save"),
            disabled: _vm.disabledSavingButton,
            type: "primary",
          },
          on: { onClick: _vm.onSaveClick },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }